import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { SubscriptionRunStatuses } from "constants/reportSubscriptions";
import { formatInOffset } from "helpers/reportSubscriptions";

const useStyles = makeStyles()(() => ({
	row: {
		fontSize: "13px",
		color: "#374151",
	},
	label: {
		fontWeight: 600,
		marginRight: "4px",
	},
	dot: {
		display: "inline-block",
		width: "8px",
		height: "8px",
		borderRadius: "50%",
		marginRight: "5px",
		verticalAlign: "middle",
	},
	success: {
		backgroundColor: "#22c55e",
	},
	failed: {
		backgroundColor: "#ef4444",
	},
	error: {
		fontSize: "12px",
		color: "#b91c1c",
		marginTop: "2px",
	},
}));

const SubscriptionLastRunStatus = ({ subscription }) => {
	const { classes, cx } = useStyles();
	const { lastRunStatus, lastRunAt, lastRunError, timezone } = subscription;
	if (lastRunStatus === SubscriptionRunStatuses.None || !lastRunStatus) {
		return (
			<Typography className={classes.row}>
				<span className={classes.label}>Last run:</span>
				Not yet run
			</Typography>
		);
	}
	const failed = lastRunStatus === SubscriptionRunStatuses.Failed;
	const runDate = formatInOffset(lastRunAt, timezone) || "Never";
	return (
		<>
			<Typography className={classes.row}>
				<span className={classes.label}>Last run:</span>
				{runDate} —{" "}
				<span
					className={cx(classes.dot, failed ? classes.failed : classes.success)}
				/>
				{failed ? "Failed" : "Success"}
			</Typography>
			{failed && lastRunError ? (
				<Typography className={classes.error}>Error: {lastRunError}</Typography>
			) : null}
		</>
	);
};

export default SubscriptionLastRunStatus;
